import React from 'react';
import PropTypes from 'prop-types';
import { Card, Typography, Button, Space } from 'antd';
import { videoStyles } from '../../utils/videoStyles';

const { Title, Text } = Typography;

const PostVideoCall = ({ onReturnToChat, config = {} }) => {
  return (
    <div style={videoStyles.centerContent}>
      <div style={videoStyles.maxWidthDiv}>
        <Card>
          <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
            <Title level={4}>Video call completed</Title>
            <Text>
              This view can be used to collect post video call CSAT or other
              data capture.
            </Text>
            {onReturnToChat && (
              <Button type="primary" onClick={onReturnToChat} block>
                Return to Chat
              </Button>
            )}
          </Space>
        </Card>
      </div>
    </div>
  );
};

PostVideoCall.propTypes = {
  onReturnToChat: PropTypes.func,
  config: PropTypes.object,
};

export default PostVideoCall;



